var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "graph",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7199de",
    fillRule: "evenodd",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5240276,7.75286045 C18.8849362,3.81946192 15.5439551,0.893223318 11.5606408,0.778032041 C11.3712496,0.770607471 11.1866786,0.838795252 11.0476041,0.967567972 C10.9085296,1.09634069 10.8263664,1.27512895 10.819222,1.4645309 L10.819222,1.4645309 L10.819222,1.52860413 L11.2677346,8.23798631 C11.2971553,8.68963908 11.6854431,9.03296725 12.1372998,9.00686503 L18.8649887,8.55835245 C19.0545568,8.54433433 19.2307086,8.45529979 19.3544148,8.31097595 C19.4781209,8.16665211 19.5391671,7.97895558 19.5240276,7.78947372 L19.5240276,7.75286045 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90160187,4.76887874 C7.32955892,4.6698867 7.76749954,4.88885701 7.94508013,5.29061788 C7.99159691,5.38511243 8.01956182,5.48765047 8.02745999,5.59267737 C8.11899318,6.89244855 8.31121286,9.73913048 8.42105267,11.2768879 C8.43980624,11.5538919 8.56817808,11.8120016 8.77775927,11.9940967 C8.98734046,12.1761918 9.2608492,12.2672571 9.53775748,12.2471396 L9.53775748,12.2471396 L15.1853548,11.8993136 C15.4374833,11.8841581 15.6846679,11.9738616 15.8683955,12.1471897 C16.0521232,12.3205177 16.1560616,12.5620622 16.155608,12.8146454 L16.155608,12.8146454 C15.9267391,16.2250189 13.4765028,19.076053 10.1393049,19.8150645 C6.80210698,20.5540759 3.37727198,19.004057 1.72997713,16.0091534 C1.23822668,15.1471838 0.92681194,14.1942547 0.814645313,13.2082381 C0.766693752,12.9056309 0.748300453,12.5990759 0.759725404,12.2929062 C0.769439164,8.6509094 3.32723354,5.51283929 6.89244855,4.76887874"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.a0e1d5766c0f8d656e64e92268baf3f1.svg";
export { ForwardRef as ReactComponent };